import { NotificationManager } from 'react-notifications';
import { Observable } from 'rxjs';
import { config } from '../../config/config';
import { utilService } from '../utils';
import { ApiService } from './api.service';

export const SubscribedUserService = {
  saveSubscribedUser,
  updateSubscribedUser,
  getSubscribedUsers,
  deleteSubscribedUser,
  generatePDF,
  getPdfStatus,
  getPdfs,
  deletePdf,
};

function saveSubscribedUser(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.subscribed_users, {
      method: 'POST',
      headers: {
        Authorization: data.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }else{
          console.log('error......', error)
          if(error.status === 400 && error.message === '[ERROR] Subscribed user already exist in database'){
            observer.error(error.message); 
          }
        }
      });
  });
}

function updateSubscribedUser(data) {
  return Observable.create((observer) => {
    fetch(
      config.api_url +
        config.url.subscribed_users +
        data.data['subscribedusersUid'],
      {
        method: 'PUT',
        headers: {
          Authorization: data.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data.data),
      }
    )
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getSubscribedUsers(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.subscribed_users + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
        'Content-Type': 'application/json',
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function deleteSubscribedUser(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.subscribed_users + data.id, {
      method: 'DELETE',
      headers: {
        Authorization: data.token,
        'Content-Type': 'application/json',
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function generatePDF(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.generate_pdf, {
      method: 'POST',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        console.log(error);
        observer.error(error.message);
        // if (error.status === 401) {
        //   window.location.reload();
        // }
      });
  });
}

function getPdfStatus(data) {
  return Observable.create((observer) => {
    fetch(
      config.api_url + config.url.generate_pdf + data.id + '/' + data.params,
      {
        method: 'GET',
        headers: {
          Authorization: data.token,
          'Content-Type': 'application/json',
        },
      }
    )
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getPdfs(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.generate_pdf, {
      method: 'GET',
      headers: {
        Authorization: data.token,
        'Content-Type': 'application/json',
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function deletePdf(data) {
  return ApiService.apiRequest(
    config.api_url + config.url.generate_pdf + data.id,
    {
      method: 'DELETE',
      headers: {
        Authorization: data.token,
        'Content-Type': 'application/json',
      },
    }
  );
}
